export default {
  table: {
    name: "Название",
    code: "Код",
    phone: "Телефон",
    email: "Электронная почта",
    first_name: "Имя",
    last_name: "Фамилия",
    mobile_number: "Номер мобильного телефона",
    city: "Город",
    country: "Страна",
    address: "Адрес",
    mobile: "Мобильный телефон",
    state: "Область/Регион",
    country_code: "Код страны",
    company_code: "Код компании",
    company_name: "Название компании",
    app_id: "ID приложения",
    city_zone: "Район города",
    area_code: "Почтовый индекс",
    time_zone: "Часовой пояс",
  },

  table_product: {
    product_name: "Название товара",
  },

  table_approval: {
    title: "Схема согласования",
    add: "Добавить схему согласования",
    edit: "Редактировать схему согласования",
    person: "Ответственный за согласование",
    create_time: "Дата создания",
    note: "Примечание:",
  },
};

